import AxisConfigScaleLevel from './axis-config-scale-level.entity';

export default class AxisConfig {
  public id: string;

  public type: string;

  public label: string;

  public description: string;

  public scaleLevels: AxisConfigScaleLevel[];

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.type = obj.type || '';
    this.label = obj.label || '';
    this.description = obj.description || '';
    this.scaleLevels = (obj.scaleLevels || []).map(
      (level: any) => new AxisConfigScaleLevel(level),
    ).sort((a, b) => a.position - b.position);
  }
}
